import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nickname: localStorage.getItem('nickname') || '用户昵称',
    token: '',
    channelCode: '', // 渠道号
    signature: '', // 签名
    timestamp: '',
    showPopupPlayer: false,
    popupPlayerInfo: {},
    popupPlayerType: 1,
    setRingObj: {},
  },
  getters: {
    nickname(state) {
      localStorage.setItem('nickname', state.nickname);
      return state.nickname;
    },
  },
  mutations: {
    setNickname(state, val) {
      state.nickname = val;
    },
    setToken(state, val) {
      state.token = val;
    },
    setChannelCode(state, val) {
      state.channelCode = val;
    },
    setSignature(state, val) {
      state.signature = val;
    },
    setTimestamp(state, val) {
      state.timestamp = val;
    },
    openPopupPlayer(state) {
      state.showPopupPlayer = true;
    },
    closePopupPlayer(state) {
      state.showPopupPlayer = false;
      state.popupPlayerType = 1;
      state.popupPlayerInfo = {};
    },
    setPopupPlayerInfo(state, val) {
      state.popupPlayerInfo = val;
    },
    setPopupPlayerType(state, val) {
      state.popupPlayerType = val;
    },
    updateSetRingObj(state, val) {
      state.setRingObj = val;
    },
  },
  actions: {},
  modules: {},
});
